// DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
(function () {
    'use strict';
    angular
        .module('superChannelApp')
        .constant('VERSION', "3.3.0")
        .constant('GOOGLE_STATIC_MAPS_API', "AIzaSyDRzwFUpA-G2JVTYfLv8K9QSuE4h6PMXEE")
;
})();
